const strengths = [
  { icon: "ri-timer-flash-line", text: "最短即日対応" },
  { icon: "ri-money-cny-circle-line", text: "見積無料" },
  { icon: "ri-check-double-line", text: "追加料金なし" },
  { icon: "ri-map-pin-line", text: "京都府全域対応" },
];

export default function ServiceHero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_aa380496827698b94475baad6122aa0b_15673ba2.jpg"
          alt="京都の伝統的な町並みと清潔な回収トラックが調和する、明るく爽やかな不用品回収サービスのイメージ"
          fetchPriority="high"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 z-[1] bg-gradient-to-b from-white/80 via-white/50 to-transparent md:bg-gradient-to-r md:from-white/80 md:via-white/50 md:to-transparent"></div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-8 pt-28 md:pt-36 pb-16 md:pb-20">
        <nav
          aria-label="パンくずリスト"
          className="mb-6 text-xs md:text-sm text-foreground-500"
        >
          <a
            href="/"
            className="hover:text-primary-600 cursor-pointer transition-colors"
          >
            ホーム
          </a>
          <span className="mx-2 text-foreground-300">&gt;</span>
          <span className="text-foreground-700 font-medium">不用品回収</span>
        </nav>

        <p className="font-mincho text-accent-800 text-base md:text-lg tracking-[0.15em] mb-4 md:mb-5">
          京都の不用品回収・粗大ゴミ処分
        </p>

        <h1 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-foreground-950 leading-[1.5] tracking-wide">
          京都の不用品回収・
          <span className="text-primary-600">粗大ゴミ処分</span>
        </h1>

        <p className="mt-5 md:mt-6 text-sm md:text-base text-foreground-700 leading-[1.9] max-w-2xl">
          家具・家電・大型ゴミからお部屋まるごとまで、京都の不用品回収・不用品処分は京都ゴミ処分センターにお任せください。
          <br className="hidden md:block" />
          最短即日対応・見積無料。軽トラ1台から、分別・搬出まで込みで、京都府全域を丁寧に回収します。
        </p>

        <div className="mt-7 md:mt-9 flex flex-col sm:flex-row gap-3">
          <a
            href="tel:0120024747"
            className="inline-flex items-center justify-center gap-2.5 px-6 py-4 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-bold text-sm md:text-base whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-phone-fill text-lg md:text-xl"></i>
            電話で無料相談
          </a>
          <a
            href="https://lin.ee/xf3zQex"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2.5 px-6 py-4 rounded-md bg-accent-700 hover:bg-accent-800 text-background-50 font-bold text-sm md:text-base whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-line-fill text-lg md:text-xl"></i>
            LINEで写真見積り
          </a>
        </div>

        <div className="mt-8 md:mt-10 flex flex-wrap gap-3">
          {strengths.map((s) => (
            <div
              key={s.text}
              className="flex items-center gap-2 px-3.5 py-2 rounded-full bg-background-50 border border-background-200"
            >
              <i className={`${s.icon} text-primary-600 text-sm`}></i>
              <span className="text-xs font-bold text-foreground-800 whitespace-nowrap">
                {s.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}